import { render, staticRenderFns } from "./PromosEditForm.vue?vue&type=template&id=a2c08a04"
import script from "./PromosEditForm.vue?vue&type=script&lang=js"
export * from "./PromosEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports